import { useState } from 'react';
import ConsultingFormModal from '../../../components/ConsultingFormModal';

export default function FinalCTA() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const scrollToSelfDiagnosis = () => {
    const selfDiagnosisSection = document.getElementById('self-diagnosis');
    if (selfDiagnosisSection) {
      selfDiagnosisSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section id="consulting-form" className="py-16 md:py-24 bg-gradient-to-br from-blue-600 to-blue-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6 md:space-y-8">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight px-2">
              점검부터 증빙까지, 모든 과정을 함께하겠습니다
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed px-4">
              견적 문의를 남겨주시면 3영업일 이내로 견적서 발송 및 친절한 상담 도와드리겠습니다
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 pt-4 md:pt-6 px-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="w-full sm:w-auto px-6 md:px-10 py-3 md:py-4 bg-white text-blue-600 text-base md:text-lg font-bold rounded-lg hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                무료 견적 신청하기
              </button>
              <button
                onClick={scrollToSelfDiagnosis}
                className="w-full sm:w-auto px-6 md:px-10 py-3 md:py-4 bg-blue-700 text-white text-base md:text-lg font-bold rounded-lg border-2 border-white/30 hover:bg-blue-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                자가진단 시작하기
              </button>
            </div>
          </div>
        </div>
      </section>

      <ConsultingFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
